import React from "react";
import salesItemCalculator from "../helpers/salesItemCalculator";
import currencyFormat from "../helpers/currencyFormat";

const GigFinancialDataTableRow = ({ sale, recipientNames }) => {

  const item = salesItemCalculator(sale);
  // console.log("Item", item);

  return (
    <tr>
      <td>{item.name}</td>
      <td className="center hideLtTablet">{item.numberSold}</td>
      <td className="center hideLtTablet">{item.numberGifted}</td>
      <td className="center hideLtTablet">{item.numberPaypal}</td>
      <td className="right hideLtTablet" >{currencyFormat(item.totalRevenue / 100)}</td>
      <td className="right hideLtTablet">{currencyFormat(item.paypalCommission / 100)}</td>
      <td className="right">{currencyFormat(item.netRevenue / 100)}</td>
      {
        recipientNames.length > 0 && recipientNames.map(recipientName => {
          const recipient = item.recipientShares
            .find(recipientShare => recipientShare.name === recipientName)
            ||
            { name: "", share: 0 };
          return (
            <td className="right">{currencyFormat(recipient.share / 100)}</td>
          )
        })
      }
    </tr>
  );

};

export default GigFinancialDataTableRow;